import CollectionGridSelector from "./modules/CollectionGridSelector";
import ProductGrid from "./modules/ProductGrid";

new CollectionGridSelector();
new ProductGrid();
